import {html, TemplateResult, LitElement, css} from 'lit';
import {property, customElement, query, state} from 'lit/decorators.js';
// import wuMachineTranslationCss from './wu-machine-translation-widget.scss';
import {classMap} from 'lit-html/directives/class-map.js';
import {getConfig} from '../../core/service/config.service';
import {Language, EventConfig} from '../../core/models/wu.interface';
import {helperService} from '../../core/service/helper.service';

@customElement('wu-machine-translation-widget')
export class WipoMachineTranslation extends LitElement {
  createRenderRoot() {
    return this;
  }
  @query('#google-translate-container')
  private google_translate_Container?: HTMLElement;

  // @query('#wipo-translate-dropdown')
  // private wipo_translate_dropdown: HTMLElement;

  @query('#container')
  private container: HTMLElement;

  @property({attribute: 'google-widget', type: Boolean})
  googleWidget: boolean = false;

  @property({attribute: 'atac-widget-pagelanguage'})
  atacWidgetPagelanguage: string = 'en'; //optional

  @property({attribute: 'atac-widget-site'}) //aka: data-mt-widget-site
  atacWidgetSite: string = getConfig().siteId;

  @property({attribute: 'atac-widget-id'}) // not configurable
  atacWidgetId: string = 'taptaWidgetUrl';

  @property({attribute: 'atac-widget-languages', type: Array})
  atacWidgetLanguages: Array<Language> = [
    {id: 'es', value: 'Español'},
    {id: 'fr', value: 'Français'},
    {id: 'ru', value: 'Русский'},
    {id: 'zh', value: '中文'},
    {id: 'ar', value: 'عربي'},
  ];

  @property({attribute: 'look-and-feel'})
  lookAndFeel: string = 'ulf';

  // private _tranlsateInterval = null;
  private _googleApiUrl =
    'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  private _atacApiUrl = getConfig().atacUrl;
  private _isHoverEnabled = true;
  private _isMobile = false;
  private _observer: MutationObserver;
  private _callbackTimeout;

  @state()
  _showMobileIcon: boolean = false;

  @state()
  _googleTranslateEnabled: boolean = false;

  @state()
  _isMachineTranslationVisible = true;

  @state()
  _showDropdown = false;

  @state()
  _showWipoTranslate = false;

  private _isWipoTranslateActivted = false;
  private _isGoogleTranslateActivted = false;
  private _isMtWidgetEnabled = false;
  private _isGoogleWidgetEnabled = false;

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('loaded', 'true');
    this.loadGoogleTranslateScript();
    this.loadAtacTranslateScript();
    window.addEventListener('resize', this._handleResize.bind(this));
    this._init();
    this._assetLoader();
  }

  _translationCallback() {
    if (this._googleTranslateEnabled) {
      const languages = this._getCookie('googtrans');
      if (languages) {
        this._dispatchEvent('googletranslate', languages[0], languages[1]);
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._handleResize);
    if (this._observer) {
      this._observer.disconnect();
    }
  }

  _assetLoader() {
    const url = getConfig().ulf;
    const linkElement = document.querySelector(`link[href="${url}"]`);
    if (!linkElement) {
      this.innerHTML += `<link
      rel="stylesheet"
      type="text/css"
      href="${url}ulf-fonts.css">`;
    }
  }

  _init() {
    if (window.innerWidth <= 768) {
      this._enableMobileView();
    } else {
      this._enableDesktopView();
    }
  }

  _handleResize() {
    if (window.innerWidth <= 768) {
      if (!this._isMtWidgetEnabled && !this._isGoogleWidgetEnabled) {
        this._enableMobileView();
      }
    } else {
      if (!this._isMtWidgetEnabled && !this._isGoogleWidgetEnabled) {
        this._enableDesktopView();
      }
    }
  }

  _enableMobileView() {
    this._isMachineTranslationVisible = false;
    this._isMobile = true;
    this._showMobileIcon = true;
  }

  _enableDesktopView() {
    this._isMachineTranslationVisible = true;
    this._isMobile = false;
    this._showMobileIcon = false;
  }

  loadGoogleTranslateScript() {
    const script = document.createElement('script');
    script.src = this._googleApiUrl;
    this.appendChild(script);
    //document.head.appendChild(script);
  }

  loadAtacTranslateScript() {
    const script = document.createElement('script');
    script.src = this._atacApiUrl;
    script.setAttribute('data-mt-widget-site', this.atacWidgetSite);
    script.id = this.atacWidgetId;
    this.appendChild(script);
  }

  googleTranslateElementInit() {
    this._googleTranslateEnabled = true;
    this._isHoverEnabled = false;
    this._isGoogleTranslateActivted = true;
    if (typeof google !== 'undefined' && google.translate?.TranslateElement) {
      console.log('google');

      new google.translate.TranslateElement(
        {pageLanguage: 'en'},
        this.google_translate_Container
      );
      this._isGoogleWidgetEnabled = true;
      //clearInterval(this._tranlsateInterval);
    } else {
      // this._tranlsateInterval = setInterval(() => {
      //   this.googleTranslateElementInit();
      // }, 100);
    }
  }

  atacTranslateElementInit(targetLanguage: string) {
    this._dispatchEvent(
      'wipotranslate',
      this.atacWidgetPagelanguage,
      targetLanguage
    );
    triggerWidgetTranslate(this.atacWidgetPagelanguage, targetLanguage);
    this._isMachineTranslationVisible = false;
    this._isMtWidgetEnabled = true;
    this._closeMachineTranslation(true);
    this._onCloseAtatcWidget();
  }

  _onCloseAtatcWidget() {
    document.getElementById('btnShowOrigin').addEventListener('click', () => {
      this._isMachineTranslationVisible = true;
      this._isMtWidgetEnabled = false;
      setTimeout(() => {
        if (this._isMobile) {
          this._closeTranlsationMobile();
        }
      }, 0);
      this._init();
    });
  }

  _getCookie(name: string): Array<string> | null {
    try {
      let cookieArr = document.cookie.split(';');
      let value: string;

      cookieArr.forEach((ele) => {
        let cookie = ele.split('=');
        if (name == cookie[0].trim()) {
          value = cookie[1];
        }
      });

      return value ? value.split('/').filter(Boolean) : null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  }

  _openDropdown() {
    if (this._isHoverEnabled) {
      this._showDropdown = true;
      this.container.classList.add('open');
    }
  }

  _closeDropdown() {
    if (this._isHoverEnabled) {
      this._showDropdown = false;
      this.container.classList.remove('open');
    }
  }

  _toggleWipoTranslate() {
    this._showWipoTranslate = !this._showWipoTranslate;
    // const target = event.currentTarget as HTMLElement;
    this._isHoverEnabled = false;
    if (this._showWipoTranslate) {
      this._isWipoTranslateActivted = true;
      //target.classList.add('active');
    } else {
      this._isWipoTranslateActivted = false;
      //target.classList.remove('active');
    }
  }

  _closeMachineTranslation(closeMachineTranslate?: boolean) {
    this._isHoverEnabled = true;
    this._closeDropdown();
    this._isWipoTranslateActivted = false;
    this._showWipoTranslate = false;
    !closeMachineTranslate ? this._closeGoogleTranslate(true) : null;
  }

  _triggerAction() {
    if (window.innerWidth > 768) {
      this._closeMachineTranslation();
    } else {
      this._closeTranlsationMobile();
    }
  }

  _closeTranlsationMobile() {
    this._showMobileIcon = true;
    this._closeMachineTranslation();
    this._isMachineTranslationVisible = false;
  }

  _openMachineTranslation() {
    this._isMachineTranslationVisible = true;
    this._showMobileIcon = false;
    setTimeout(() => {
      this._openDropdown();
    }, 0);
  }

  _closeGoogleTranslate(initialize?: boolean) {
    this._googleTranslateEnabled = false;
    this._isGoogleTranslateActivted = true;
    let iframe = document.getElementById(':1.container');
    if (iframe) {
      let innerDoc: Document | undefined;

      if (iframe instanceof HTMLIFrameElement) {
        innerDoc = iframe.contentDocument;
      } else {
        innerDoc = (iframe as HTMLIFrameElement)?.contentWindow?.document;
      }

      if (innerDoc) {
        let closeButton = innerDoc.getElementById(':1.close');
        if (closeButton) {
          this._isGoogleWidgetEnabled = false;
          closeButton.click();
          initialize ? this._init() : null;
        }
      }
    }
  }

  _dispatchEvent(
    tranlsationType: string,
    sourceLanguage: string,
    language: string
  ) {
    const evtConfig: EventConfig = {
      event: 'wsitCustomEvent',
      eventName: `${tranlsationType}-${sourceLanguage}-${language}`,
      eventCategory: 'Machine Translation',
      eventAction: 'wsitMachineTranslation',
      eventValue: 1,
      eventDetail: null,
    };
    helperService.addEvents('wsitCustomEvent', this, evtConfig);
  }

  updated() {
    const targetElement = document.getElementById('translationDetector');
    if (targetElement) {
      this._observer = new MutationObserver(() => {
        clearTimeout(this._callbackTimeout);
        this._callbackTimeout = setTimeout(() => {
          this._translationCallback();
        }, 300);
      });
      const config = {childList: true, subtree: false, attributes: true};
      this._observer.observe(targetElement, config);
    }

    // setTimeout(() => {
    //   this._observer.disconnect();
    // }, 0);
  }

  static styles = [
    css`
      .wu-translation {
        color: red;
      }
    `,
  ];

  get className() {
    return `${this.lookAndFeel} wu-translation notranslate`;
  }

  template() {
    const wipoTranslated = {
      'wipo-translate': true,
      active: this._isWipoTranslateActivted,
    };
    const googleTranslated = {
      active: this._isGoogleTranslateActivted,
    };

    return html`${
      this._showMobileIcon
        ? html`<div @click="${this._openMachineTranslation}">
            <span class="icons translation-logo circle">translate</span>
          </div>`
        : null
    }
      <section
        id="machine-translation"
        style="display: ${this._isMachineTranslationVisible ? 'block' : 'none'}"
        class="${this.className}"
      >
        <div
          id="container"
          class="translation-container"
          @mouseenter="${this._openDropdown}"
          @mouseleave="${this._closeDropdown}"
        >
          <div class="translation-label">
            <span class="icons translation-logo">translate</span>
            <span class="translation-heading">Machine translation</label>
          </div>
          <span class="icons close-translation" @click="${this._triggerAction}"
            >close</span
          >
        </div>
        <div
          style="display: ${this._showDropdown ? 'block' : 'none'}"
          class="translation-drop-down"
          id="wipo-translate-dropdown"
          @mouseenter="${this._openDropdown}"
          @mouseleave="${this._closeDropdown}"
        >
          <ul>
            ${
              !this._googleTranslateEnabled
                ? html`<li>
                    <a
                      href="javascript:void(0)"
                      class="${classMap(wipoTranslated)}"
                      @click="${this._toggleWipoTranslate}"
                      >WIPO Translate
                      <span class="icons float-right">expand_more</span></a
                    >
                    ${this._showWipoTranslate
                      ? html`<ul class="translation-languages">
                          ${this.atacWidgetLanguages.length
                            ? html`${this.atacWidgetLanguages.map(
                                (language: Language) =>
                                  html`<li>
                                    <a
                                      href="javascript:void(0)"
                                      @click="${() =>
                                        this.atacTranslateElementInit(
                                          language.id
                                        )}"
                                      >${language.value}</a
                                    >
                                  </li>`
                              )}`
                            : null}
                        </ul>`
                      : null}
                  </li>`
                : null
            }
            <li style="display: ${this.googleWidget ? 'block' : 'none'}">
              ${
                !this._googleTranslateEnabled
                  ? html`<a
                      href="javascript:void(0)"
                      @click="${this.googleTranslateElementInit}"
                      >Google Translate
                      <span class="icons float-right">arrow_forward</span></a
                    >`
                  : null
              }
              <ul
                class="${classMap(googleTranslated)}"
                style="display: ${
                  this._googleTranslateEnabled ? 'block' : 'none'
                }"
              >
                <li class="google-translate">
                  <a
                    href="javascript:void(0)"
                    @click="${() => this._closeGoogleTranslate(false)}"
                    ><span class="icons">arrow_back</span></a
                  >
                  <div id="google-translate-container"></div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </section>
      <div id="translationDetector" style="display:none;">tranlsation detector</div>
      `;
  }

  render(): TemplateResult {
    return html`${this.template()}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'wu-machine-translation-widget': WipoMachineTranslation;
  }
}
